import { transformServerFormatToClient } from '../../lib/buttonModelV3';
import { getServerProps } from '../../utils/serverProps';
import {
  CREATE_DEFAULT_BUTTON,
  CREATE_DEFAULT_BUTTON_SUCCESS,
  CREATE_DEFAULT_BUTTON_ERROR,
  DELETE_BUTTON,
  DELETE_BUTTON_SUCCESS,
  DELETE_BUTTON_ERROR,
  GET_BUTTON,
  GET_BUTTON_SUCCESS,
  GET_BUTTON_ERROR,
  UPDATE_VOUCHER_LISTING_STATUS,
  UPDATE_VOUCHER_LISTING_STATUS_SUCCESS,
  UPDATE_VOUCHER_LISTING_STATUS_ERROR,
} from './actionsManager';

const defaultState = {
  busy: true,
};

function getFormattedButton(payload) {
  // organizationName is not stored in BF service
  // fetching from server to make sure it gets pre-filled when user is editing/duplicating a button
  return Object.assign({}, transformServerFormatToClient(payload), {
    receiverName: getServerProps().receiverName,
    language: payload.language,
    offerProgram: payload.offerProgram,
  });
}

export default function buttonManagerV3(state = defaultState, action) {
  switch (action.type) {
    case CREATE_DEFAULT_BUTTON: {
      return {
        ...state,
        isSending: true,
        busy: false,
      };
    }

    case CREATE_DEFAULT_BUTTON_SUCCESS: {
      return {
        ...state,
        isSending: false,
        busy: false,
      };
    }

    case CREATE_DEFAULT_BUTTON_ERROR: {
      return {
        ...state,
        error: action.error,
        isSending: false,
        busy: false,
      };
    }

    case GET_BUTTON: {
      return {
        ...state,
        isSending: true,
        busy: true,
      };
    }

    case GET_BUTTON_SUCCESS: {
      const button = action.payload;
      const formattedButton = getFormattedButton({
        ...button,
        businessImageUrls: action.businessImageUrls,
        merchantExperienceUrls: action.merchantExperienceUrls,
      });

      return {
        ...state,
        button,
        formattedButton,
        isSending: false,
        busy: false,
      };
    }

    case GET_BUTTON_ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        error,
        isSending: false,
        busy: false,
      };
    }

    case DELETE_BUTTON: {
      return {
        ...state,
        isSending: true,
        busy: false,
      };
    }

    case DELETE_BUTTON_SUCCESS: {
      return {
        ...state,
        isSending: false,
        busy: false,
      };
    }

    case DELETE_BUTTON_ERROR: {
      return {
        ...state,
        error: action.error,
        isSending: false,
        busy: false,
      };
    }

    case UPDATE_VOUCHER_LISTING_STATUS: {
      return {
        ...state,
        isSending: true,
        busy: true,
      };
    }

    case UPDATE_VOUCHER_LISTING_STATUS_SUCCESS: {
      return {
        ...state,
        isSending: false,
        busy: false,
      };
    }

    case UPDATE_VOUCHER_LISTING_STATUS_ERROR: {
      return {
        ...state,
        error: action.error,
        isSending: false,
        busy: false,
      };
    }

    default:
      return state;
  }
}
